import { useEffect, useState } from "react";

import styles from "./styles/Dashboard.module.scss";

import { Col, Row } from "react-bootstrap";
import { SubTitle } from "../../Components/CustomComponents";
// import MatchCard from '../../Components/Cards/MatchCard';
// import TournamentCard from '../../Components/Cards/TournamentCard';
import { FaUserAlt } from "react-icons/fa";
import { MdContentCopy, MdPriceChange } from "react-icons/md";
import DashboardCard from "../../Components/Cards/DashboardCard";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";
import ThemeChart from "../../Components/ThemeChart";
import { useGetDashboardQuery } from "../../Data/services/dashboardApi";
import { chartData, chartOptions } from "../../constants";
import { ROUTES } from "./constants";

export default function Dashboard({ setPage }) {
  const { data, isLoading, isFetching } = useGetDashboardQuery();
  const [updatedData, setupdatedData] = useState([]);

  let bg1 = "#FF2E2E";
  let bg2 = "#FF0000";
  let iconColor = "rgba(249, 35, 35, 1)";
  const handleViewLiveMatches = () => {
    setPage(ROUTES.LIVE_MATCHES);
  };

  const handleViewTournament = () => {
    setPage(ROUTES.TOURNAMENTS);
  };
  const getMonthName = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("default", { month: "short" });
  };

  useEffect(() => {
    const updatedData = [];
    chartData.labels.forEach((month) => {
      const dataForMonth = data?.data?.revenue_graph?.find(
        (item) => getMonthName(item.month) === month
      );
      updatedData.push(dataForMonth ? dataForMonth.revenue : 0);
    });
    setupdatedData(updatedData);
  }, [data]);

  const cardData = [
    {
      icon: <FaUserAlt color={iconColor} />,
      number: isLoading ? <LoadingButton /> : data?.data?.creators_count,
      text: "Creators Count",
    },
    {
      icon: <MdPriceChange color={iconColor} />,
      number: isLoading ? <LoadingButton /> : data?.data?.total_pricing_plans,
      text: "Pricing Plans",
    },
    {
      icon: <MdContentCopy color={iconColor} />,
      number: isLoading ? <LoadingButton /> : data?.data?.total_public_contents,
      text: "Public Contents",
    },
    {
      icon: <MdContentCopy color={iconColor} />,
      number: isLoading ? (
        <LoadingButton />
      ) : (
        data?.data?.total_subscription_contents
      ),
      text: "Subscription Content",
    },
    {
      icon: <MdContentCopy color={iconColor} />,
      number: isLoading ? <LoadingButton /> : data?.data?.viewers_count,
      text: "Viewers Count",
    },
    {
      icon: <MdContentCopy color={iconColor} />,
      number: isLoading ? <LoadingButton /> : data?.data?.total_reported_content,
      text: "Total Reported Content",
    },
    {
      icon: <MdContentCopy color={iconColor} />,
      number: isLoading ? <LoadingButton /> : `$${data?.data?.admin_revenue?.total}`,
      text: "Admin Revenue",
    },
    {
      icon: <MdContentCopy color={iconColor} />,
      number: isLoading ? <LoadingButton /> : `$${data?.data?.admin_revenue?.custom_requests}`,
      text: "Custom Requests",
    },
    {
      icon: <MdContentCopy color={iconColor} />,
      number: isLoading ? <LoadingButton /> : `$${data?.data?.admin_revenue?.tips}`,
      text: "Tips",
    },
    {
      icon: <MdContentCopy color={iconColor} />,
      number: isLoading ? <LoadingButton /> : data?.data?.total_unapproved_creators,
      text: "Total Unapproved Creators",
    },
  ];
  return (
    <div className={styles.Dashboard}>
      <div className={styles.headerContainer}>
        <div className={styles.titleContainer}>
          <SubTitle text={"Dashboard"} />
        </div>
      </div>
      <Row className={`${styles.matchRow} w-100 mt-3`}>
        {cardData?.slice(0, 8)?.map((card, index) => (
          <Col key={index} className="mt-2 mb-2" lg={3} md={3} sm={6}>
            <DashboardCard
              bg1={bg1}
              bg2={bg2}
              icon={card.icon}
              number={card.number}
              text={card.text}
            />
          </Col>
        ))}
      </Row>

      <Row className={`${styles.matchRow} w-100 mb-3`}>
        {cardData?.slice(8, 10)?.map((card, index) => (
          <Col key={index} className="mt-2 mb-2" lg={6} md={6} sm={6}>
            <DashboardCard
              bg1={bg1}
              bg2={bg2}
              icon={card.icon}
              number={card.number}
              text={card.text}
            />
          </Col>
        ))}
      </Row>
      <Row>
        <Col md={12}>
          <div className={"themeChart"}>
            <ThemeChart
              type="line"
              data={updatedData}
              chartOptions={chartOptions}
              loading={isLoading}
            />
            {/* <MonthDropdown
              selectedMonth={selectedMonth}
              setSelectedMonth={setSelectedMonth}
            /> */}
          </div>
        </Col>
      </Row>
    </div>
  );
}
